export default __webpack_public_path__ + "static/media/union.37dadd4e.svg";